<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.live_url.title' | translate"
  [description]="'organizer.edit.live_url.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="formGroup.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  [previousUrl]="previousUrl"
  (submitted)="validateForm()"
  [skipSaveModal]="true"
>
  <ng-container [formGroup]="formGroup">
    <app-form-input-group
      class="block mb-3"
      [label]="'organizer.edit.live_url.input.url.label' | translate"
      [errors]="liveUrl?.touched && liveUrl?.errors"
      errorKey="url"
    >
      <app-form-input
        #content
        formControlName="liveUrl"
        type="text"
        [placeholder]="
          'organizer.edit.live_url.input.url.placeholder' | translate
        "
        [required]="true"
      ></app-form-input>
    </app-form-input-group>

    <app-form-input-group
      [label]="
        'organizer.edit.live_url.input.note_for_attendees.label' | translate
      "
      [errors]="noteForAttendees?.touched && noteForAttendees?.errors"
      errorKey="noteForAttendees"
    >
      <app-form-input
        #content
        formControlName="noteForAttendees"
        type="text"
        [placeholder]="
          'organizer.edit.live_url.input.note_for_attendees.placeholder'
            | translate
        "
      ></app-form-input>
    </app-form-input-group>
  </ng-container>

  <app-tips
    #rightColumn
    right-column
    [icon]="iconType.Information"
    [title]="'organizer.edit.live_url.tips.title' | translate"
    [tips]="'organizer.edit.live_url.tips.description' | translate"
  ></app-tips>

  <app-modal-edit-timeslots
    #modalEditTimeslots
    [isLastTimeslot]="isLastTimeslot"
    (updateTimeslot)="applyToSession()"
    (updateSelectedTimeslots)="updateSelectedTimeslots()"
    (updateAllTimeslots)="updateAllTimeslots()"
  >
  </app-modal-edit-timeslots>
</app-organizer-shared-layout-edit-field>
